import React from "react";

import "./BankSupplierDetails.scss";
import { Mode } from "../../../../../shared/constants";
import { Grid } from "@material-ui/core";
import DetailComponent from "../../../common-components/details-component";
import BankForm from "../../../common-components/forms/bank-form";
import { useTranslation } from "react-i18next";

const BankSupplierDetails = (props) => {
  const { t } = useTranslation();
  const { mode, supplier, supplierFormData, setSupplierFormData } = props;

  return <div className="supplier-details">
    {mode === Mode.view && <Grid container spacing={3}>
      <Grid item xs={6}><DetailComponent label={t("bank-name")} value={supplier.bank_name}/> </Grid>
      <Grid item xs={6}><DetailComponent label={t("bank-number")} value={supplier.bank_number}/> </Grid>
      <Grid item xs={6}><DetailComponent label={t("bank-branch-number")} value={supplier.bank_branch_number}/> </Grid>
      <Grid item xs={6}><DetailComponent label={t("bank-account-number")} value={supplier.bank_account_number}/> </Grid>
    </Grid>}
    {mode === Mode.edit && <BankForm bankFormData={supplierFormData} setBankFormData={setSupplierFormData}/>}
  </div>
}

export default BankSupplierDetails;
